import { render } from "./XperiaMain.vue?vue&type=template&id=6fa9dbd6&scoped=true&ts=true"
import script from "./XperiaMain.vue?vue&type=script&lang=ts"
export * from "./XperiaMain.vue?vue&type=script&lang=ts"

import "./XperiaMain.vue?vue&type=style&index=0&id=6fa9dbd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa9dbd6"]])

export default __exports__